<!-- 扫码登录+绑定手机号 -->
<template>
    <div class="box" style=" width: 100%;
    min-height: 550px ;">


        <!-- 扫码登录 -->
        <div style="width: 100%;height: 100%;" v-if="codeShow">
            <div class="code" @click="codeswitch"></div>
            <div class="login-titles">
                <span style="color: #212020">扫码登录</span>
            </div>
            <div class="wxcode" v-if="codeShow">
                <iframe id="wxiframe" frameborder="no" sandbox="allow-scripts allow-top-navigation" :src="vCode"></iframe>
                <div class="login-logon">
                    没有账号？<span style="color: red" @click="register">立即注册</span>
                </div>
            </div>
        </div>

        <!-- 账号登录 -->
        <div class="login-titles" v-if="passShow">
            <span style="color: #212020">设置登录密码</span>
            <span style="float: right; font-size: 14px">已有账号？<span style="color: red" @click="loginto">直接登录</span></span>
        </div>

        <div class="login-titles" v-if="phoneShow">
            <!-- <div class="login-titles" v-if="true"> -->
            <span style="color: #212020">绑定手机号</span>
            <span style="float: right; font-size: 14px">已有账号？<span style="color: red" @click="loginto">直接登录</span></span>
            <div>依据网络安全法，为保障您的账户安全，请绑定手机号。</div>
        </div>

        <!-- 已有账号 -->
        <div class="login-titles" v-if="promptShow" style="">
            <span style="color: #212020">绑定手机号</span>
            <span style="float: right; ">已有账号？<span style="color: red" @click="loginto">直接登录</span></span>
        </div>
        <div v-if="wxShow">
            <div class="login-prompt">
                <span>手机号{{ this.telphone }}已有账号， 是否绑定该微信？</span>
            </div>
            <div class="login-btn">
                <el-button class="button" @click="setNext">确定
                </el-button>
                <el-button class="button" @click="previous">返回</el-button>
            </div>
        </div>


        <!-- 绑定过其他微信 -->
        <div v-if="wxtShow">
            <div class="login-prompt">
                <span>手机号{{ this.telphone }}已有账号， 且该账号已绑定过其他微信， 请用该号码直接登录~</span>
            </div>
            <div class="login-btn">
                <el-button class="button" @click="loginto">去登陆
                </el-button>
                <el-button class="button" @click="previous">返回</el-button>
            </div>
        </div>

        <div v-if="succShow">
            <div class="login-prompt">
                <el-image class="login-img" :src="require('../imgs/success.png')">
                </el-image>
                <span class="login-cen" v-if="successShow">注册成功</span>
                <span class="login-cen" v-if="!successShow">绑定成功</span>
            </div>
            <div class="login-btn">
                <el-button class="button" @click="loginBtt">立即登录
                </el-button>

            </div>
        </div>
        <el-form class="logina" :model="ruleForm" :rules="rules" ref="ruleForm" v-if="phoneShow">
            <el-form-item class="login-row" prop="receiveNo">
                <el-input v-model="ruleForm.receiveNo" placeholder="手机号" @blur="testItem" />
                <!-- @blur="testItem" -->
            </el-form-item>
            <el-form-item label="验证" prop="isLock" v-if="slideShow ? true : false">
                <sliderVerifyCode v-model="ruleForm.isLock" @change="handlerLock"></sliderVerifyCode>
            </el-form-item>

            <el-form-item class="login-row" prop="control">
                <el-input :type="showPwd ? 'text' : 'password'" style="width: 65%" v-model="ruleForm.control"
                    placeholder="短信验证码" />
                <el-button size="small" type="button" :disabled="btnShow ? false : true" style="float: right"
                    class="btn btn-info" id="send" @click="getCode(ruleForm)">
                    <span v-show="count_show">发送验证码</span>
                    <span v-show="!count_show" class="count">{{ count }} </span>
                </el-button>
            </el-form-item>
            <el-form-item class="forget">
                <el-checkbox v-model="checked">我已同意并愿意准守 <a href="">《用户协议》</a></el-checkbox>
            </el-form-item>
            <el-button :disabled="ruleForm.receiveNo && ruleForm.control && checked ? false : true" class="login-bttn"
                @click="login">提交验证</el-button>
            <!-- <div class="login-bttn disabled"  @click="login">提交验证</div> -->
        </el-form>
        <!-- 验证码登录 -->
        <el-form class="logina" :model="rulesForm" :rules="formRules" ref="rulesForm" v-if="passShow">
            <el-form-item class="login-row" prop="pwd">
                <el-input type="text" v-model="rulesForm.pwd" placeholder="密码" />
            </el-form-item>
            <el-form-item class="login-row" prop="againpwd">
                <el-input :type="showPwd ? 'text' : 'password'" style="width: 65%" v-model="rulesForm.againpwd"
                    placeholder="确认密码" />
                <img v-show="!showPwd" src="../imgs/eye-no.svg" @click="showPwd = true" class="eye-icon" />
                <img v-show="showPwd" src="../imgs/eye.svg" @click="showPwd = false" class="eye-icon" />
            </el-form-item>
            <el-button :disabled="rulesForm.pwd && rulesForm.againpwd ? false : true" class="login-bttn" @click="passbut">
                确定</el-button>
        </el-form>
    </div>
</template>
<script>
import sliderVerifyCode from "@/components/slider-verify-code.vue";
export default {
    // name: "scanCode",
    props: ['msg'],
    components: { sliderVerifyCode },
    data() {

        //const count = 60;  倒计时的时间
        const checkStatus = (rule, value, callback) => {
            if (!value) {
                return callback(new Error("请按住滑块，拖动到最右边"));
            } else {
                if (
                    this.ruleForm.receiveNo == "" || !this.ruleForm.receiveNo
                ) {
                    setTimeout(() => {
                        this.ruleForm.isLock = false;
                        this.$refs.ruleForm.validateField("receiveNo");
                        // this.$refs.form.validateField("pass");
                        return callback(new Error("验证未通过"));
                    }, 1);
                }
                callback();
            }
        };

        // 手机号码验证
        const validatePhone = (rule, value, callback) => {
            if (!value) {
                callback(new Error("手机号不能为空！"));
            }
            //使用正则表达式进行验证手机号码
            if (!/^1[3456789]\d{9}$/.test(value)) {
                callback(new Error("手机号不正确！"));
            }

            callback();
            //  this.slideShow = true
            return validatePhone.value;
        };

        // 密码是否一致
        const validatePwd = (rule, value, callback) => {
            if (!value) {
                callback(new Error("不能为空！"));
            }
            //使用正则表达式进行验证手机号码
            // console.log(validatePhone.value);

            if (value != this.ruleForm.pwd) {
                callback(new Error("两次输入密码不一致！"));
                console.log(validatePhone.value);
            }
            callback();
        };

        // 密码格式是否正确
        const validatePsdReg = (rule, value, callback) => {
            if (!value) {
                return callback(new Error("请输入密码"));
            }
            if (!/^(?![\d]+$)(?![a-zA-Z]+$)(?![^\da-zA-Z]+$)([^\u4e00-\u9fa5\s]){6,20}$/.test(value)
            ) {
                callback(
                    new Error(
                        "请输入6-20位英文字母、数字或者符号（除空格），且字母、数字和标点符号至少包含两种"
                    )
                );
            } else {
                callback();
            }
        };
        return {
            vCode: '',//微信二维码
            ruleForm: {
                receiveNo: "",
                control: "",
            },
            rulesForm: {
                pwd: "",
                againpwd: "",
            },
            slideShow: false,
            btnShow: false,
            showPwd: false,
            phoneShow: false,
            promptShow: false,
            wxShow: false,
            wxtShow: false,
            passShow: false,
            succShow: false,
            successShow: false,
            checked: "",
            name: "",
            telphone: "13525506507",
            form: {},
            count: 1,
            count_show: true,
            codeShow: true,
            stateCode: "",   // 令牌校验码
            rules: {
                isLock: [{ validator: checkStatus, trigger: "blur" }],
                control: [{ required: true, message: "请输入验证码", trigger: "blur" }],
                pwd: [
                    {
                        required: true,
                        validator: validatePsdReg,
                        trigger: "blur",
                    },
                ],
                receiveNo: [
                    { required: true, validator: validatePhone, trigger: "blur" },
                ],
                againpwd: [{ required: true, validator: validatePwd, trigger: "blur" }],
            },
            formRules: {
                pwd: [
                    { required: true, validator: validatePsdReg, trigger: "blur" }, { min: '6', max: '16', trigger: "blur" }],
                againpwd: [{ required: true, validator: validatePwd, trigger: "blur" }],
            },
        };
    },
    created() {
        console.log(this.$route);


    },
    mounted() {
        // var obj = new WxLogin({
        //     self_redirect: true,
        //     id: "wxiframe",
        //     appid: "wxe8e80094df9f9cd7",
        //     scope: "snsapi_login",
        //     redirect_uri: "https://www.yunshangzg.com",
        //     state: "",
        //     style: "black",
        //     href: "data:text/css;base64,LmltcG93ZXJCb3ggLnFyY29kZSB7d2lkdGg6IDIwMHB4O30KLmltcG93ZXJCb3ggLnRpdGxlIHtkaXNwbGF5OiBub25lO30KLmltcG93ZXJCb3ggLmluZm8ge3dpZHRoOiAyMTBweDt9Ci5pbXBvd2VyQm94IC5pY29uMzhfbXNnLnN1Y2Mge2Rpc3BsYXk6IG5vbmV9Ci5pbXBvd2VyQm94IC5pY29uMzhfbXNnLndhcm4ge2Rpc3BsYXk6IG5vbmV9Ci5pbXBvd2VyQm94IC5zdGF0dXMge3RleHQtYWxpZ246IGNlbnRlcjt9Cg=="
        // });
        // location.reload()
        // 示例

        if (this.hasQueryString()) {
            this.codeShow = false;
            this.phoneShow = true;
            this.passShow = false;
            this.promptShow = false;
            this.wxShow = false;
            console.log('二维码显示状态', this.phoneShow);
        } else {
            this.getVCode()
        }


    },
    methods: {
        hasQueryString() {
            return window.location.search !== '';
            // 如果地址栏中有参数，则返回true；否则返回false
        },


        async getVCode() {
            const res = await this.$axios.get("/weiXin/register")
            // console.log(res);
            this.vCode = res
            // console.log(this.vCode);
            // window.location(res)


        },


        // 判断手机号状态
        login() {
            this.$axios
                .get(`weiXin/judgeStatusTel?telphone=${this.ruleForm.receiveNo}&code=${this.ruleForm.control}`)
                .then((res) => {
                    console.log(res);
                    console.log(res.code);
                    if (res.code == '20001') {
                        this.codeShow = false;
                        this.phoneShow = false;
                        this.passShow = false;
                        this.promptShow = true;
                        this.wxShow = true;
                        // let stateData = JSON.parse(res)
                        // console.log(stateData)

                        this.stateCode = res.data
                        this.$message.success(res.msg);
                    } else if (res.code == '20003') {
                        this.codeShow = false;
                        this.phoneShow = false;
                        this.promptShow = false;
                        this.wxShow = false;
                        this.passShow = true
                        this.stateCode = res.data

                        this.$message.success(res.msg);

                    } else if (res.code == '20002') {
                        this.codeShow = false;
                        this.phoneShow = false;
                        this.promptShow = true;
                        this.wxtShow = true;
                        // this.stateCode = JSON.parse(res.data)
                        this.$message.error(res.msg);
                        // console.log(this.stateCode)
                    } else if (res.code == '5000') {
                        this.$message.error(res.msg);
                    }
                })
                .catch((err) => {
                    alert(err)
                    console.log(err);
                });
        },
        // 验证用户是否注册
        testItem() {
            console.log('okkkkk')
            this.telphone = this.ruleForm.receiveNo
            if (!/^1[3456789]\d{9}$/.test(this.telphone)) {
                return false;
            }
            this.slideShow = true

            // this.$axios
            //     .get(`/weiXin/existenceTel?telphone=${this.telphone}`)
            //     .then((res) => {
            //         console.log(res);
            //         console.log(res.code);
            //         if (!res.success) {
            //             console.log('用户未注册')
            //             this.slideShow = true

            //             // this.$message({
            //             //   message: res.msg,
            //             //   type: "success",
            //             // });
            //         } else {
            //             this.$message.error('用户' + res.data);
            //         }
            //     })
            //     .catch((err) => {
            //         alert(err)
            //         console.log(err);
            //     });

        },
        // 发送短信验证码
        getCode() {
            this.count = 60; //倒计时时间
            this.count_show = false; //控制倒计时显示隐藏
            var reg_tel = /^(13[0-9]|14[01456789]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-3509])\d{8}$/;
            if (this.ruleForm.receiveNo == '') {
                alert('请填写手机号!');
                return false;
            } else if (!reg_tel.test(this.ruleForm.receiveNo)) {
                alert('请填写正确的手机号!');
                return false;
            }
            console.log(this.ruleForm.receiveNo);
            let params = {
                telphone: this.ruleForm.receiveNo
            };
            this.$axios.get('/weiXin/getCode', { params }).then(res => {
                this.btnShow = false
                console.log(res);
            })
            this.timer = setInterval(() => {
                if (this.count > 0) {
                    this.count--;
                } else {
                    clearInterval(this.timer);
                    this.count_show = true;
                    this.btnShow = true;
                }
            }, 1000);
        },
        // 滑块
        handlerLock(data) {
            if (data) {
                this.$refs.ruleForm.validateField("isLock");
            }
            this.btnShow = true;

        },
        // 登录
        loginto() {
            // let that = this;
            // that.twoShow = true;
            // that.twoShow = true;
            // that.$emit("loginto", that.twoShow);
            // that.loginShow = true;
            window.location.href = "./login";
        },
        // 回登录页面
        codeswitch() {
            let that = this;
            that.twoShow = true;
            that.$emit("codefun", that.twoShow);
        },
        // 立即注册
        register() {
            // let that = this;
            // that.loginShow = true;
            this.twoShow = true;
            this.$emit("transfer", this.twoShow)
        },
        // 提交密码
        passbut() {
            let userInfo = localStorage.getItem('userInfo')
            console.log(userInfo)
            console.log(JSON.parse(userInfo))
            let info = JSON.parse(userInfo)
            let id = info.openid
            let headimage = info.headimgurl
            let username = info.nickname
            let sex = info.sex
            console.log(id)

            this.$axios.post(`/weiXin/sweepCodeRegister?stateCode=${this.stateCode}`, {
                headimage: headimage,
                oppenid: id,
                password: this.rulesForm.pwd,
                sex: sex,
                telphone: this.telphone,
                username: username,
            })
                .then((res) => {
                    console.log(res);
                    console.log(res.code);
                    if (res.code = '2000') {
                        console.log(res.msg)
                        this.phoneShow = false
                        this.succShow = true
                        this.successShow = true

                        this.codeShow = false;
                        this.passShow = false;
                        this.promptShow = true;
                        this.wxShow = false;
                        this.wxtShow = false;

                        // this.$message({
                        //   message: res.msg,
                        //   type: "success",
                        // });
                    } else {
                        this.$message.error('用户' + res.data);
                    }
                })
                .catch((err) => {
                    alert(err)
                    console.log(err);
                });

        },
        // 返回
        previous() {
            this.codeShow = false;
            this.phoneShow = true;
            this.passShow = false;
            this.promptShow = false;
            this.wxShow = false;
            this.wxtShow = false;
        },
        // 下一步 绑定
        setNext() {
            // let userInfo = localStorage.getItem('userInfo')
            // console.log(userInfo)
            // // console.log(userInfo.openid)
            // console.log(JSON.parse(userInfo))
            let userInfo = this.$route.query.date
            let info = JSON.parse(userInfo)
            console.log(this.$route.query.date);
            console.log(info);
            console.log(this.telphone);

            this.$axios
                .post(`/weiXin/existingAccount?telphone=${this.telphone}&openid=${info.openid}&wechatName=${info.nickname}&headImage=${info.headimgurl}`)
                .then((res) => {
                    console.log(res);
                    console.log(res.code);
                    if (res.code == '2000') {
                        this.succShow = true
                        this.successShow = false

                        this.phoneShow = false
                        this.codeShow = false;
                        this.passShow = false;
                        this.promptShow = true;
                        this.wxShow = false;
                        this.wxtShow = false;
                    } else {
                        this.$message({
                            message: res.data,
                            type: "error",
                        });
                        // this.$message.error('用户' + res.data);
                    }
                })
                .catch((err) => {
                    alert(err)
                    console.log(err);
                });
        },
        // 立即跳转登录
        loginBtt() {
            window.location.href = "./login";

            // window.location.href = "/";


        }
    },
};
</script>
<style lang="scss" scoped>
.logina {
    padding: 0 50px 50px 50px;
}

.login-titles {
    font-size: 14px;
    padding: 0 20px 0px;
    color: #b2b2b2;
    margin-top: 40px;
}

.code {
    position: absolute;
    right: 0;
    top: 0;
    width: 80px;
    height: 80px;
    background-image: url(../imgs/board1.png);
    background-size: 100% 100%;
    border-top-right-radius: 10px;

    &:after {
        display: block;
        content: "";
        width: 0;
        height: 0;
        border: 40px solid #fff;
        border-right-color: transparent;
        border-top-color: transparent;
        border-top-right-radius: 10px;
    }
}


.login-row {
    /* margin-top: 78px; */
    width: 100%;
    border-bottom: 1px solid #e5e5e5;
    padding-bottom: 10px;
    margin-top: 35px;
}

.login-row input {
    font-size: 18px;
    outline: none;
    border: none;
    flex: 1;
    height: 22px;
}

.login-row>>>.el-input__inner {
    font-size: 18px;
    outline: none;
    border: none;
    flex: 1;
    height: 22px;
    width: 100%;
}

.login-row .eye-icon {
    width: 24px;
    height: 20px;
    object-fit: contain;
    cursor: pointer;
}

.forget {
    font-size: 14px;
    float: right;
    font-weight: normal;
    line-height: 20px;
    letter-spacing: 0px;
    color: #999999;
}

.login-bttn {
    width: 100%;
    height: 50px;
    background-color: #f08a92 !important;
    margin-top: 30px;
    display: flex;
    border-radius: 6px;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    color: #fff !important;
    cursor: pointer;
}

.login-bttn.disabled {
    background-color: #f08a92;
    cursor: not-allowed;
}

.login-logon {
    font-size: 14px;
    // margin: 10px 130px;
}

.wxcode {
    // overflow: hidden;
    width: 100%;
    height: 80%;
    display: flex;
    align-items: center;
    flex-direction: column;
    // height: 400px;
    // display: inline-block;
    // margin: 0px auto;

    #wxiframe {
        width: 90%;
        height: 100%;
    }

}




.login-prompt {
    position: relative;
    padding: 50px;
    height: 220px;
    font-size: 18px;
    width: 350px;
    margin: 0 auto;
}

.login-btn {
    // margin-top: 100px;
    // display: block;
    // border-radius: 6px;
    // align-items: center;
    // justify-content: center;
    // font-size: 18px;
    // color: #ffffff;
    cursor: pointer;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
}

.login-btn>>>.el-button {
    width: 340px;
    height: 50px;
    color: #ffffff;
    background-color: #f08a92;
    text-align: center;
    // margin-left: 50px;

}

.el-button+.el-button {
    margin-top: 30px;
    // margin-left: 50px;
}

.login-btn.disabled {
    background-color: #f08a92;
    cursor: not-allowed;
}

.login-img {
    position: absolute;
    // color: #b8b8b8;
    // margin: 20px auto;
    padding-bottom: 20px;
    left: 50%;
    bottom: 40%;
    transform: translate(-50%, -50%);
    // margin: 0 auto;
}

.login-cen {
    position: absolute;
    color: #ed2222;
    // margin: 20px auto;
    padding-top: 20px;
    left: 50%;
    bottom: 40%;

    transform: translate(-50%, -50%);
    // margin: 0 auto;
}

.button {
    width: 340px;
    height: 50px;
}


body,
body.theme-light {
    background-color: #ededed;
    padding: 1rem;
}

body.theme-dark {
    background-color: #444;
    color: #fff;
}
</style>




// WEBPACK FOOTER //
// src/components/scanCode.vue